export default {
  menu: 'Reports',
  title: 'Reports',

  logs: {
    menu: 'Logs',
    title: 'Logs',

    general: {
      table: {
        header: {
          rowNumber: 'Row',
          createdAt: 'Log history',
          userName: 'User',
          description: 'Description',
          details: 'Details',
          type: 'Activity type'
        }
      },

      dialogs: {
        title: 'Log Details',
        withoutDescription: 'No further description'
      }
    },

    list: {
      title: 'Logs'
    }
  },

  usersTotalSales: {
    menu: 'Total sales to individuals',
    title: 'Total sales to individuals',

    table: {
      header: {
        row: 'Row',
        name: 'Name and surname',
        company: 'Company',
        phoneNumber: 'Mobile',
        totalSales: 'Total Sales',
        date: 'Date'
      }
    }
  },

  sale: {
    menu: 'Sale',
    title: 'Sale'
  },

  productsTotalSales: {
    title: 'Product Total Sales',

    labels: {
      today: 'Today',
      lastDays: 'Last {day} days',
      allTime: 'All time',
      customRange: 'Custom Range',
      withoutRecentPurchase: 'Excluding purchases last {day} days'
    },

    table: {
      header: {
        rowNumber: 'Row',
        image: 'Photo',
        barcode: 'Barcode',
        code: 'Code',
        name: 'Title',
        variant: 'Variable',
        category: 'Category',
        inventoryCount: 'Inventory',
        invoicesCount: 'Invoices',
        soldQuantity: 'Sold',
        totalProfit: 'Profit',
        totalSales: 'Total sales',
        price: 'Regular price',
        salePrice: 'Sale price',
        purchasePrice: 'Purchase price',
      }
    },

    setting: {
      title: 'Inventory Settings',
      description: 'Stock received through purchase invoices in the last few days will not be counted in the report. Sale returns and other receipts are still counted.',

      labels: {
        day: 'Days',
        dayQuantity: 'Number of days'
      },

      helps: {
        dayQuantity: 'Set to {number} to disable this setting.'
      }
    }
  },

  charts: {
    main: {
      labels: {
        selectChart: 'Edit active charts',
        startRange: 'Select start range',
        endRange: 'Select end range',
        hourly: 'Hourly',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        quarterly: 'Quarterly',
        yearly: 'Yearly',
        range: 'Range',
        today: 'today',
        week: 'this week',
        month: 'this month',
        year: 'this year',
        sale: 'Sale',
        totalSale: 'Total sells',
        personalSale: 'Retail',
        telephoneSale: 'Telephone',
        onlineSale: 'Online',
        grossProfit: 'Sells profit',
        receive: 'Receive',
        payment: 'Payment',
        cost: 'Cost',
        creditor: 'Creditor',
        debtor: 'Debtor',
        default: 'default',
        price: 'price ({currency})'
      },

      metrics: {
        purchase_chart: 'Purchase',
        domestic_purchase_chart: 'Domestic purchase',
        import_purchase_chart: 'Import purchase',
        gift_purchase_chart: 'Gift purchase',
        sale_chart: 'Sale',
        domestic_sale_chart: 'Domestic sale',
        export_sale_chart: 'Export sale',
        gift_sale_chart: 'Gift sale',
        gross_profit_chart: 'Gross profit',
        domestic_gross_profit_chart: 'Domestic gross profit',
        export_gross_profit_chart: 'Export gross profit',
        cost_chart: 'Cost',
        credit_user_chart: 'Credit',
        debit_user_chart: 'Debit',
        receive_chart: 'Receive',
        payment_chart: 'Payment'
      },

      notifications: {
        chartNotSelected: 'Choose at least one chart'
      }
    },
    appStatus: {
      title: 'Time remaining',

      labels: {
        status: 'Status',
        active: 'Active',
        disable: 'Disable',
        startDate: 'From date ',
        endDate: 'End date ',
        dynamicTotal: 'From {day} days',
        remainDays: 'Remain days',
        passedDays: 'Passed days'
      }
    },
    assets: {
      title: 'Assets',
      labels: {
        treasury: 'Treasury',
        banks: 'Bank',
        cashes: 'Cash',
        payment_gateways: 'Payment gateway'
      }
    },
    attributeAssets: {
      title: 'Attributes Sale',

      labels: {
        dateRange: 'From {start} to {end}',
        today: 'Today',
        yesterday: 'Yesterday',
        week: 'Last week',
        month: 'Last month',
        selectDate: 'Select date',
        price: 'Price ({currency})',
        category: 'Category',
        withoutCategory: 'Without category',
        simpleProduct: 'Simple product',
        saleProfit: 'Profit',
        totalSale: 'Sale',
        totalProfit: 'Total Profit',
        totalPrice: 'Total Price'
      },

      notifications: {
        parseError: {
          rangeLength: 'Date range should less thant 1 year',
          endRange: 'End range is not valid'
        }
      }
    }
  },

  tops: {
    products: {
      title: 'Top products',

      table: {
        header: {
          row: 'Row',
          name: 'Product name',
          quantity: 'Quantity',
          score: 'Point',
          saleInventory: 'Sale inventory',
          show: 'Show'
        }
      }
    },

    customer: {
      title: 'Top customers',

      labels: {
        profile: 'Profile',
        lastWeek: 'Last week',
        lastMonth: 'Last month',
        lastYear: 'Last year'
      },

      table: {
        header: {
          row: 'Row',
          name: 'Full name',
          phoneNumber: 'Phone number',
          price: 'Price',
          score: 'Point',
          show: 'Show'
        }
      }
    },

    invoice: {
      title: 'Latest today sale invoices',

      table: {
        header: {
          row: 'Row',
          invoiceNumber: 'Invoice number',
          name: 'Customer name',
          status: 'Status',
          show: 'Show'
        }
      }
    }
  }
}
